import React, { Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LenisRoot } from "@/components/LenisRoot";
import Home from "@/pages/Home";
import Preferences from "@/pages/Preferences";
import Unsubscribe from "@/pages/Unsubscribe";
import Confirm from "@/pages/Confirm";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FDFCF8", color: "#28382D", fontFamily: "Manrope, sans-serif" }} className="px-6 text-center">
          <div>
            <p className="font-serif text-3xl mb-3">Something wobbled.</p>
            <p className="text-moss">Please refresh the page — everything is probably fine.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function NotFound() {
  return (
    <div style={{ minHeight: "80vh" }} className="flex items-center justify-center px-6 text-center">
      <div>
        <p className="font-serif text-3xl text-ink mb-3">This page is resting.</p>
        <a href="/" className="link-quiet">Go back to the quiet home page</a>
      </div>
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <div className="grain min-h-screen bg-paper text-ink">
        <BrowserRouter>
          <ScrollToTop />
          <LenisRoot />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/preferences/:token" element={<Preferences />} />
            <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
            <Route path="/confirm/:token" element={<Confirm />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster
            position="bottom-center"
            toastOptions={{
              style: {
                background: "#28382D",
                color: "#F5EFE6",
                borderRadius: "18px",
                border: "none",
              },
            }}
          />
        </BrowserRouter>
      </div>
    </ErrorBoundary>
  );
}

export default App;
